module.exports = __webpack_public_path__ + "images/products/device-serial-image-0c92a2ef.svg";